import { useCallback, useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { useCamp } from "~/api2/hooks/useCamp"
import { useCampingStyles } from "~/api2/hooks/useCampingStyles"
import { useModal } from "~/contexts/ModalProvider"
import { useNotification } from "~/contexts/NotificationProvider"
import ILineItem from "~/interfaces/ILineItem"
import { ROUTER_PATHS } from "~/routes/constants"

export const useStoreContent = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { openModal, closeModal } = useModal()
  const { showNotification } = useNotification()
  const {
    index: { data: camp },
  } = useCamp()
  const {
    index: { data: campingStyles },
  } = useCampingStyles()
  const [lineItems, setLineItems] = useState<ILineItem[]>([])
  const [activeTab, setActiveTab] = useState<string>("pos")

  useEffect(() => {
    if (location.pathname) {
      if (location.pathname === ROUTER_PATHS.ADMIN_STORE_POS) setActiveTab("pos")
      if (location.pathname === ROUTER_PATHS.ADMIN_STORE_HISTORY) setActiveTab("history")
    }
  }, [location])

  const handleRemoveItem = (id: string | null): void => {
    if (!id) return

    setLineItems((prev) => {
      const updatedItems = [...prev]

      const index = updatedItems.findIndex((item) => item.add_on_id === id)

      if (index > -1) {
        updatedItems.splice(index, 1)
      }

      return updatedItems
    })
  }

  const changeTab = useCallback((active: string) => {
    if (active === "pos") navigate(ROUTER_PATHS.ADMIN_STORE_POS)
    if (active === "history") navigate(ROUTER_PATHS.ADMIN_STORE_HISTORY)
  }, [navigate])

  return {
    lineItems,
    camp,
    campingStyles,
    setLineItems,
    handleRemoveItem,
    openModal,
    closeModal,
    showNotification,
    activeTab,
    changeTab,
  }
}
